export default __webpack_public_path__ + "static/media/Montserrat-Black.08437fd0.ttf";